import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Award, BookOpen, Users, Heart } from 'lucide-react';

const AboutPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-main)' }}>
      {/* Hero */}
      <section style={{
        padding: '4rem 1.2rem 3rem',
        background: 'var(--gradient-hero)',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <Link to="/" className="body-small" style={{ textDecoration: 'none', color: 'var(--text-secondary)', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '2rem' }}>
            <ArrowLeft size={16} /> Retour à l'accueil
          </Link>
          <h1 className="heading-hero" style={{ marginBottom: '1rem' }}>À Propos</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>Découvrez qui se cache derrière APDR de la VAE</p>
        </div>
      </section>

      {/* Image + Presentation */}
      <section style={{ padding: '3rem 1.2rem' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <div style={{
            display: 'flex', gap: '2.5rem', alignItems: 'flex-start', flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            {/* Image */}
            <div style={{ flexShrink: 0 }}>
              <img 
                src="https://customer-assets.emergentagent.com/job_242bc5c9-743a-4a4d-8064-6a0a5dff2ea7/artifacts/mur321pl_image.png"
                alt="Rose - APDR de la VAE"
                style={{
                  width: '320px', maxWidth: '100%', borderRadius: '1.25rem',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                  border: '3px solid #E75480'
                }}
              />
            </div>

            {/* Text */}
            <div style={{ flex: 1, minWidth: '300px' }}>
              <div style={{
                background: 'linear-gradient(135deg, #fff 0%, #FFF0F3 100%)',
                border: '2px solid #E75480',
                borderRadius: '1rem',
                padding: '1.75rem 2rem',
                marginBottom: '1.5rem',
                boxShadow: '0 4px 20px rgba(231, 84, 128, 0.12)'
              }}>
                <p style={{ marginBottom: '1rem', color: '#4A3050', lineHeight: 1.8, fontSize: '1.05rem' }}>
                  Je suis <strong style={{ color: '#E75480' }}>Rose</strong>, accompagnatrice VAE depuis plus de <strong>10 ans</strong> et membre de jury depuis <strong>13 ans</strong> dans le secteur sanitaire, social et de la petite enfance.
                </p>
                <p style={{ color: '#4A3050', lineHeight: 1.8, fontSize: '1.05rem', marginBottom: 0 }}>
                  Je suis titulaire du <strong style={{ color: '#E75480' }}>DEAP</strong>, du <strong style={{ color: '#E75480' }}>DEEJE</strong> et du <strong style={{ color: '#E75480' }}>CAFERUIS</strong>. Je suis également formée en <strong>psychanalyse</strong> et en <strong>sophrologie</strong>, ce qui me permet d'accompagner les candidats à la fois sur le plan méthodologique et sur la confiance en soi face aux étapes de la VAE.
                </p>
              </div>

              <p className="body-medium" style={{ marginBottom: '1rem', color: '#6B5B7A', lineHeight: 1.7 }}>
                J'accompagne les candidats dans leur réflexion, la rédaction de leur livret 2 et la préparation de leur oral afin de leur donner toutes les clés pour réussir leur certification.
              </p>
              <p className="body-medium" style={{ marginBottom: '1rem', color: '#6B5B7A', lineHeight: 1.7 }}>
                Les formations proposées sur cet espace ont été conçues à partir des besoins réels des candidats. Elles vous apportent des outils pédagogiques concrets pour comprendre les attentes du jury et avancer efficacement dans votre démarche VAE, même en autonomie.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mon parcours */}
      <section style={{ padding: '3rem 1.2rem', background: 'var(--bg-section)' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '2rem' }}>Mon parcours</h2>
          
          <div style={{
            background: 'linear-gradient(135deg, #FFF0F3 0%, #fff 100%)',
            borderRadius: '1rem', padding: '2rem', marginBottom: '2rem',
            border: '1px solid #E7548020'
          }}>
            <p style={{ fontSize: '1.15rem', fontStyle: 'italic', color: '#E75480', fontWeight: 600, marginBottom: '1.5rem', textAlign: 'center' }}>
              "Si j'ai réussi, toi aussi tu peux réussir."
            </p>
            <p style={{ color: '#4A3050', lineHeight: 1.8, marginBottom: '1rem' }}>
              Bac SMS. Doutes. Reconversion. Manque de diplôme. Puis j'ai découvert la VAE.
            </p>
            <p style={{ color: '#4A3050', lineHeight: 1.8, marginBottom: '1rem' }}>
              <strong>DEAP · DEEJE · CAFERUIS.</strong>
            </p>
            <p style={{ color: '#4A3050', lineHeight: 1.8, marginBottom: '1rem' }}>
              Aujourd'hui, j'ouvre ma 4e structure et je dirige mes équipes avec légitimité.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '1rem' }}>
              <p style={{ color: '#4A3050', lineHeight: 1.8, margin: 0 }}><Heart size={16} style={{ color: '#E75480', display: 'inline', verticalAlign: 'middle', marginRight: '0.4rem' }} />Rien n'est figé.</p>
              <p style={{ color: '#4A3050', lineHeight: 1.8, margin: 0 }}><Award size={16} style={{ color: '#3B82F6', display: 'inline', verticalAlign: 'middle', marginRight: '0.4rem' }} />Un diplôme peut tout changer.</p>
              <p style={{ color: '#4A3050', lineHeight: 1.8, margin: 0 }}><BookOpen size={16} style={{ color: '#10B981', display: 'inline', verticalAlign: 'middle', marginRight: '0.4rem' }} />Une décision peut transformer une trajectoire.</p>
            </div>
          </div>

          {/* CTA */}
          <div style={{ textAlign: 'center' }}>
            <p className="body-large" style={{ marginBottom: '1.5rem', color: '#4A3050' }}>
              Si vous hésitez à vous lancer dans la VAE ou si vous voulez sécuriser votre parcours, contactez-moi.
            </p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/booking" className="btn-primary">Réserver une séance gratuite</Link>
              <a href="https://wa.me/33688399624" target="_blank" rel="noopener noreferrer" className="btn-secondary" style={{ textDecoration: 'none' }}>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
